module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/102/assets/images/a98b34b96819910b9a8247c43ee6e18b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_dot.svg
// module id = ODC2
// module chunks = 0